export default "__VITE_ASSET__BdVwfHQT__"